import React, { createContext, useContext, useState, useLayoutEffect } from 'react'

const STORAGE_KEY = 'streamrtv-banner-dismissed'

const StreamrTvBannerContext = createContext()

export const StreamrTvBannerProvider = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false)
    const [shouldRender, setShouldRender] = useState(false)
    const [bannerHeight, setBannerHeight] = useState(0)

    // Initialize banner state synchronously to prevent layout shifts
    useLayoutEffect(() => {
        const isBannerDismissed = !!localStorage.getItem(STORAGE_KEY)
        const initialVisible = !isBannerDismissed

        setIsVisible(initialVisible)
        setShouldRender(initialVisible)
        setBannerHeight(initialVisible ? 40 : 0)
    }, [])

    const closeBanner = () => {
        setIsVisible(false)
        setBannerHeight(0)
        localStorage.setItem(STORAGE_KEY, 'true')

        // Remove from DOM after animation completes
        setTimeout(() => {
            setShouldRender(false)
        }, 300)
    }

    const value = {
        isVisible,
        shouldRender,
        closeBanner,
        bannerHeight,
    }

    return (
        <StreamrTvBannerContext.Provider value={value}>{children}</StreamrTvBannerContext.Provider>
    )
}

export const useStreamrTvBanner = () => {
    const context = useContext(StreamrTvBannerContext)
    if (!context) {
        throw new Error('useStreamrTvBanner must be used within a StreamrTvBannerProvider')
    }
    return context
}
